export const queryKeys = {
  storeSpecialsPage: (
    storeId: string | number,
    limit: number,
    includeHidden?: boolean
  ) => ['storeSpecialsPage', storeId, limit, includeHidden],
};
